angular.module('shared').factory('PushNotificationOptionsService', ["$q", "$http", function($q, $http) {
  return {
    getOptions: function(gymId, context) {
      var deferred, url;
      deferred = $q.defer();
      url = `/gyms/${gymId}/templates/push_notification_route_names`;
      $http({
        method: 'GET',
        url: url,
        params: {
          context: context
        }
      }).then(function(response) {
        var key, transformedData, value;
        transformedData = (function() {
          var ref, results;
          ref = response.data;
          results = [];
          for (key in ref) {
            value = ref[key];
            results.push({
              value: key,
              label: value
            });
          }
          return results;
        })();
        return deferred.resolve(transformedData);
      }).catch(function(error) {
        return deferred.reject('Request could not be completed. Please try again');
      });
      return deferred.promise;
    }
  };
}]);
